/*
 * Parses objects coming from RichTextWrapper.js
 */

export default class RichTextTokenParser { };

var REGEX_TAGS = /(?:<(.*?)>)((?:.|\r|\n|\r\n)*?)(?:<\/.*?>)/g;//1st capture: complete string, 2nd capture: tagname, 3rd: capture: text between tags
var REGEX_ATTRIBUTES = /(?:([^\s]*)='([^']*)')/g; //1st capture: complete string, 2nd capture: attributename, 3rd: capture: attribute value

RichTextTokenParser.parse = function (wordsData) {
    var group = wordsData.full;
    REGEX_TAGS.lastIndex = 0;
    var res = REGEX_TAGS.exec(group);
    var tag = wordsData.tag;
    var attributes = {};
    if (res) {
        var elementComponents = res[1].split(' ');
        elementComponents.forEach(function (component) {
            //Reset RegExp.lastIndex (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec)
            REGEX_ATTRIBUTES.lastIndex = 0;
            var attrRes = REGEX_ATTRIBUTES.exec(component);
            if (attrRes && attrRes.length === 3) {
                attributes[attrRes[1]] = attrRes[2];
            };
        });
    }

    return {
        tag: tag,
        text: wordsData.text,
        attributes: attributes,
        width: wordsData.width
    };
}